import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { MonitoringDataService } from '../services/monitoring-data.service';
import Chart from 'chart.js/auto';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-monitoring',
  standalone: true,
  templateUrl: './monitoring.component.html',
  styleUrl: './monitoring.component.scss',
  imports: [HeaderComponent, FooterComponent, HttpClientModule, CommonModule, FormsModule],
})

export class MonitoringComponent {
  isChartVisible: boolean = true;
  isLoadingVisible: boolean = true;
  title = 'ng-chart';
  chart: any = [];
  productionChart: any = null;
  monitoringData: any[] = [];
  accountNumbers: any[] = [];
  selectedAccountNumber: string = '';

  constructor(private monitoringDataService: MonitoringDataService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngAfterViewInit() {
    this.fetchAccountNumbers();
  }

  fetchAccountNumbers(): void {
    this.monitoringDataService.fetchAccountNumber().subscribe(
      (response: string[]) => {
        this.accountNumbers = response;
        this.selectedAccountNumber = this.accountNumbers[0];
        this.fetchDataAndRenderChart(this.accountNumbers[0]);
      },
      (error) => {
        this.isChartVisible = false;
        this.isLoadingVisible = false;
      }
    );
  }

  fetchDataAndRenderChart(accountNumber: string): void {
    this.loadingScreenOn();
    this.monitoringDataService.getMonitoringData(accountNumber).subscribe(
      (response) => {
        if (response.success && response.data) {

          this.isChartVisible = true;
          this.isLoadingVisible = false;

          this.monitoringData = response.data;

          const data = response.data;
          data.sort(
            (a: any, b: any) =>
              new Date(a.startDate).getTime() -
              new Date(b.startDate).getTime()
          );

          let actualData: number[] = [];
          let estimatedData: number[] = [];
          let productionData: number[] = [];
          let startDate: string[] = [];

          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            if (element.estimateIndicator === 'A') {
              actualData.push(element.billingKWh);
              estimatedData.push(0);
            } else {
              actualData.push(0);
              estimatedData.push(element.billingKWh);
            }
            startDate.push(
              new Date(element.startDate).toLocaleString('default', {
                month: 'short',
                year: 'numeric',
              })
            );
            productionData.push(element.reportedKWh);
          }

          this.chart = new Chart('canvas', {
            type: 'bar',
            data: {
              labels: startDate,
              datasets: [
                {
                  label: 'Actual Production kWh',
                  data: actualData,
                  backgroundColor: '#1283C6',
                },
                {
                  label: 'Estimated Production kWh',
                  data: estimatedData,
                  backgroundColor: '#54626F',
                },
              ],
            },
            options: {
              responsive: true,
              scales: {
                x: {
                  stacked: true,
                },
                y: {
                  stacked: true,
                },
              },
            },
          });

          this.productionChart = new Chart('canvas_Production', {
            type: 'bar',
            data: {
              labels: startDate,
              datasets: [
                {
                  label: 'Reported Production',
                  data: productionData,
                  backgroundColor: '#1283C6',
                }
              ],
            },
            options: {
              responsive: true,
              scales: {
                x: {
                  stacked: true,
                },
                y: {
                  stacked: true,
                },
              },
            },
          });

        } else {
          this.isChartVisible = false;
        }
      },
      (error) => {
        this.isChartVisible = false;
        this.isLoadingVisible = false;
      }
    );
  }

  loadingScreenOn(): void {
    this.isChartVisible = false;
    this.isLoadingVisible = true;
    this.destoryGraph();
  }

  destoryGraph(): void {
    this.chart = Chart.getChart('canvas');
    if (this.chart) {
      this.chart.destroy();
    }

    this.productionChart = Chart.getChart('canvas_Production');
    if (this.productionChart) {
      this.productionChart.destroy();
    }
  }

  downloadCSV(): void {

    const data = this.monitoringData.map(object => ({
      estimateIndicator: object.estimateIndicator,
      billingKWh: object.billingKWh,
      reportedKWh: object.reportedKWh,
      startDate: object.startDate
    }));

    this.monitoringDataService.downloadCSV(data);
  }

}
